import { Injectable } from '@angular/core';

/*
opt1: No refreral code
opt2: Optional referral code
opt3: Mandatory referral code
*/
@Injectable({
  providedIn: 'root'
})
export class PrerequisiteService {

  constructor() { }
  AppVersionType(): string {
    return "opt1";
  }
  DefaultGN(): string {
    if (this.AppVersionType() == "opt1") {
      if (window.localStorage.getItem('DevicePlatform') == "android") {
        return "HDRX9543";
      }
      else {
        return "HDRX9543";
      }
    }
    else {
      return "HDRX9543";
    }
  }
  GNForOPT2(): string {
    return "HDRX9543";
  }

  SplashImage() {
    if (this.AppVersionType() == "opt1")
      return 'assets/imgs/RxHacker.png';
    else if (this.AppVersionType() == "opt2")
      return 'assets/imgs/RxHacker.png';
    else
      return 'assets/imgs/RxHacker.png';
  }
  IsLoginRequired() {
    return "No";
  }
  randomMemberId() {
    let rand = Math.round(Math.random() * 796856320485);
    let rand_str = rand.toString().substring(0, 7);
    if (parseInt(rand_str) < 1000000) {
      this.randomMemberId();
    }
    return rand_str;
  }
  DrugDoseDescription() {
    let JsonStringStructure = "[{\"Dose\":\"AEPB\",\"Descrption\":\"Aerosolpowderbreathactivated\"},{\"Dose\":\"AERB\",\"Descrption\":\"Aerosolbreathactivated\"},{\"Dose\":\"AERO\",\"Descrption\":\"Aerosol\"},{\"Dose\":\"AERP\",\"Descrption\":\"Aerosolpowder\"},{\"Dose\":\"AERS\",\"Descrption\":\"Aerosolsolution\"},{\"Dose\":\"BAR\",\"Descrption\":\"Bar\"},{\"Dose\":\"BEAD\",\"Descrption\":\"Beads\"},{\"Dose\":\"CAPS\",\"Descrption\":\"Capsule\"},{\"Dose\":\"CHEW\",\"Descrption\":\"Tabletchewable\"},{\"Dose\":\"CONC\",\"Descrption\":\"Concentrate\"},{\"Dose\":\"CP12\",\"Descrption\":\"Capsuleextendedrelease12hr\"},{\"Dose\":\"CP24\",\"Descrption\":\"Capsuleextendedrelease24hr\"},{\"Dose\":\"CPCR\",\"Descrption\":\"Capsuleextendedrelease\"},{\"Dose\":\"CPDR\",\"Descrption\":\"Capsuledelayedrelease\"},{\"Dose\":\"CPEP\",\"Descrption\":\"Capsuledelayedreleaseparticles\"},{\"Dose\":\"CPSP\",\"Descrption\":\"Capsulesprinkle\"},{\"Dose\":\"CSDR\",\"Descrption\":\"CSDR\"},{\"Dose\":\"CREA\",\"Descrption\":\"Cream\"},{\"Dose\":\"CRYS\",\"Descrption\":\"Crystals\"},{\"Dose\":\"DEVI\",\"Descrption\":\"Device\"},{\"Dose\":\"DISK\",\"Descrption\":\"Disk\"},{\"Dose\":\"DPRH\",\"Descrption\":\"Diaphragm\"},{\"Dose\":\"ELIX\",\"Descrption\":\"Elixir\"},{\"Dose\":\"EMUL\",\"Descrption\":\"Emulsion\"},{\"Dose\":\"ENEM\",\"Descrption\":\"Enema\"},{\"Dose\":\"EXTR\",\"Descrption\":\"Fluidextract\"},{\"Dose\":\"FILM\",\"Descrption\":\"Film\"},{\"Dose\":\"FLAK\",\"Descrption\":\"Flakes\"},{\"Dose\":\"FOAM\",\"Descrption\":\"Foam\"},{\"Dose\":\"GAS\",\"Descrption\":\"Gas\"},{\"Dose\":\"GEL\",\"Descrption\":\"Gel\"},{\"Dose\":\"GRAN\",\"Descrption\":\"Granules\"},{\"Dose\":\"GREF\",\"Descrption\":\"Granuleseffervescent\"},{\"Dose\":\"GUM\",\"Descrption\":\"Gum\"},{\"Dose\":\"IMPL\",\"Descrption\":\"Implant\"},{\"Dose\":\"INHA\",\"Descrption\":\"Inhaler\"},{\"Dose\":\"INJ\",\"Descrption\":\"Injectable\"},{\"Dose\":\"INST\",\"Descrption\":\"Insert\"},{\"Dose\":\"IUD\",\"Descrption\":\"Intrauterinedevice\"},{\"Dose\":\"KIT\",\"Descrption\":\"Kit\"},{\"Dose\":\"LEAV\",\"Descrption\":\"Leaves\"},{\"Dose\":\"LIQD\",\"Descrption\":\"Liquid\"},{\"Dose\":\"LOTN\",\"Descrption\":\"Lotion\"},{\"Dose\":\"LOZG\",\"Descrption\":\"Lozenge\"},{\"Dose\":\"LPOP\",\"Descrption\":\"Lollipop\"},{\"Dose\":\"LQCR\",\"Descrption\":\"Liquidextended-Release\"},{\"Dose\":\"MISC\",\"Descrption\":\"Miscellaneous\"},{\"Dose\":\"NEBU\",\"Descrption\":\"Nebulizationsolution\"},{\"Dose\":\"OIL\",\"Descrption\":\"Oil\"},{\"Dose\":\"OINT\",\"Descrption\":\"Ointment\"},{\"Dose\":\"PACK\",\"Descrption\":\"Packet\"},{\"Dose\":\"PADS\",\"Descrption\":\"Pads\"},{\"Dose\":\"PDEF\",\"Descrption\":\"Powdereffervescent\"},{\"Dose\":\"PLLT\",\"Descrption\":\"Pellet\"},{\"Dose\":\"POWD\",\"Descrption\":\"Powder\"},{\"Dose\":\"PSTE\",\"Descrption\":\"Paste\"},{\"Dose\":\"PT24\",\"Descrption\":\"Patch24hr\"},{\"Dose\":\"PT72\",\"Descrption\":\"Patch72hr\"},{\"Dose\":\"PTCH\",\"Descrption\":\"Patch\"},{\"Dose\":\"PTTW\",\"Descrption\":\"Patchbiweekly\"},{\"Dose\":\"PTWK\",\"Descrption\":\"Patchweekly\"},{\"Dose\":\"PUDG\",\"Descrption\":\"Pudding\"},{\"Dose\":\"RING\",\"Descrption\":\"Ring\"},{\"Dose\":\"SHAM\",\"Descrption\":\"Shampoo\"},{\"Dose\":\"SHEE\",\"Descrption\":\"Sheet\"},{\"Dose\":\"SOLG\",\"Descrption\":\"Gelformingsolution\"},{\"Dose\":\"SOLN\",\"Descrption\":\"Solution\"},{\"Dose\":\"SOLR\",\"Descrption\":\"Solutionreconstituted\"},{\"Dose\":\"SPRT\",\"Descrption\":\"Spirit\"},{\"Dose\":\"STCK\",\"Descrption\":\"Stick\"},{\"Dose\":\"STRP\",\"Descrption\":\"Strip\"},{\"Dose\":\"SUBL\",\"Descrption\":\"Tabletsublingual\"},{\"Dose\":\"SUPP\",\"Descrption\":\"Suppository\"},{\"Dose\":\"SUSP\",\"Descrption\":\"Suspension\"},{\"Dose\":\"SUSR\",\"Descrption\":\"Suspensionreconstituted\"},{\"Dose\":\"SWAB\",\"Descrption\":\"Swab\"},{\"Dose\":\"SYRP\",\"Descrption\":\"Syrup\"},{\"Dose\":\"TABS\",\"Descrption\":\"Tablet\"},{\"Dose\":\"TAMP\",\"Descrption\":\"Tampon\"},{\"Dose\":\"TAPE\",\"Descrption\":\"Tape\"},{\"Dose\":\"TAR\",\"Descrption\":\"Tar\"},{\"Dose\":\"TB12\",\"Descrption\":\"Tabletextendedrelease12hr\"},{\"Dose\":\"TB24\",\"Descrption\":\"Tabletextendedrelease24hr\"},{\"Dose\":\"TBCR\",\"Descrption\":\"Tabletextended-Release\"},{\"Dose\":\"TBDP\",\"Descrption\":\"Tabletdispersible\"},{\"Dose\":\"TBEC\",\"Descrption\":\"Tabletdelayedrelease\"},{\"Dose\":\"TBEF\",\"Descrption\":\"Tableteffervescent\"},{\"Dose\":\"TBSO\",\"Descrption\":\"Tabletsoluble\"},{\"Dose\":\"TEST\",\"Descrption\":\"Diagnostictest\"},{\"Dose\":\"THPK\",\"Descrption\":\"THPK\"},{\"Dose\":\"TINC\",\"Descrption\":\"Tincture\"},{\"Dose\":\"TROC\",\"Descrption\":\"Troche\"},{\"Dose\":\"WAFR\",\"Descrption\":\"Wafer\"},{\"Dose\":\"WAX\",\"Descrption\":\"Wax\"}]";
    return JsonStringStructure;
  }
  GetUserLoggedInStatus() {
    if (this.AppVersionType() == "opt1") {
      window.localStorage.setItem('VersionGN', 'opt1');
      window.localStorage.setItem('SkipSignup', 'signupskipped');
      let getUG = window.localStorage.getItem('UserGroup');
      if (getUG == null) {
        // window.localStorage.setItem('UserGroup', this.DefaultGN());
      }
      if (this.IsLoginRequired() == "Yes") {
        if (window.localStorage.getItem('UserId') == null || window.localStorage.getItem('UserId') == '' || window.localStorage.getItem('UserId') == undefined) {
          return "signupscreen";
        }
      }
      else {
        if (window.localStorage.getItem('SkipSignup') != 'signupskipped' && window.localStorage.getItem('SkipSignup') != 'loggedin' && window.localStorage.getItem('SkipSignup') != 'signupdone') {
          return "signupscreen";
        }
      }
    }
    else {
      if (window.localStorage.getItem('SkipSignup') == 'signupskipped') {
        if (window.localStorage.getItem('UserGroup') == null || window.localStorage.getItem('UserGroup') == "False" || window.localStorage.getItem('UserGroup') == undefined) {
          // window.localStorage.setItem('UserGroup', this.DefaultGN());
          return "signupscreen";
        }
      }
      else {
        if (window.localStorage.getItem('UserId') == null || window.localStorage.getItem('UserId') == '' || window.localStorage.getItem('UserId') == undefined) {
          return "signupscreen";
        }
        else {
          if (window.localStorage.getItem('UserGroup') == null || window.localStorage.getItem('UserGroup') == "False" || window.localStorage.getItem('UserGroup') == "null" || window.localStorage.getItem('UserGroup') == "") {
            return "groupscreen";
          }
          else {
            return "loggedin"
          }
        }
      }
    }
  }
}
